import * as actionTypes from "../Actions/SandBoxApplicationsActionTypes";
import LogService from "../../CommonSdk/LogService";

const name = "REDUCER:SANDBOX_APPLICATIONS";

const initialState = {
    applications: [],
    progress: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.SANDBOX_APPLICATIONS_PROGRESS:
            LogService.info(name, "reduce", "" + action.type);
            return {
                ...state,
                applications: [],
                progress: true
            };

        case actionTypes.SANDBOX_APPLICATIONS_UPDATE:
            LogService.info(name, "reduce", "" + action.type);

            let updatedApplicationList = [...state.applications];
            action.payload.applications.forEach(element => {
                updatedApplicationList = [...updatedApplicationList.filter(application => application.id !== element.id), element];
            });

            return {
                ...state,
                applications: updatedApplicationList,
                progress: false
            };

        case actionTypes.SANDBOX_APPLICATIONS_CLEAR:
            LogService.info(name, "reduce", "" + action.type);

            return {
                ...initialState,
                progress: false
            };

        default:
            return state;
    }
}
